import { useNavigate } from "react-router-dom";

import noSavedTenders from "../../assets/addSaved.svg";
import zigzagArrow from "../../assets/trend.png";
import AuthenticationButton from "../Buttons/AuthenticationButton";

const NoSavedTenders = () => {
  const navigate = useNavigate();
  const viewAllTenders = () => {
    navigate("/tenders");
  };
  return (
    <div className="w-[95%] max-w-[480px] p-6 sm:p-8 text-[#3d5984] bg-white border border-gray-100 shadow-[0_4px_20px_rgba(61,89,132,0.1)] mt-[20%] md:mt-[10%] rounded-2xl flex flex-col items-center text-center gap-5">
      <h1 className="font-semibold text-lg md:text-xl">No Saved Tenders</h1>
      <div className="w-24 h-24 md:w-32 md:h-32">
        <img src={noSavedTenders} alt="no saved tenders" />
      </div>
      <div className="w-full flex flex-col items-center gap-3">
        <p className="text-sm text-gray-500 leading-relaxed">
          Looks like you haven't saved any tenders yet. Browse & save some
          tenders and come back to this page.
        </p>
        <img
          className="w-8 rotate-[130deg]"
          src={zigzagArrow}
          alt="zig zar arrow"
        />
        <AuthenticationButton
          onClick={viewAllTenders}
          className="w-full h-12 bg-[#664bc7] hover:bg-[#664bc7]/90 text-white rounded-xl font-semibold transition-colors relative overflow-hidden"
          name="View All Tenders"
        />
      </div>
    </div>
  );
};

export default NoSavedTenders;
